import React, {Component} from 'react';
import Btn from "../btn";
import Dialog from "../dialog";
import Email from "../email";

class AlreadySent extends Component {

    render() {
        const body =
            <div className="AlreadySent">
                <p>{'Zdá se, že někdo z kolegů Vás předběhl a dotazník už vyplnil. Váš názor nás také zajímá. Vzkázat nám jej můžete přímo na:'}</p>
                <Email email={'hodnoceni@aitom.cz'}/>
                <p>{'Chcete si udržet přehled? Víte, že píšeme blog?'}</p>
                <Btn text={'Přečíst si blog'} href={'https://www.aitom.cz/co-je-noveho'}/>
            </div>

        return <Dialog title={'Jejda, hodnocení Vaší firmy už máme'} body={body}/>;
    }
}

export default AlreadySent;


// WEBPACK FOOTER //
// ./src/components/alreadySent/index.js